import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseViewComponent } from '../../../../projects/shared/core/interfaces/baseViewComponent';
import { ToastService } from '../../../../projects/shared/core/services/toast.service';
import { LookupService } from '../../../../projects/shared/core/services/lookup.service';
import { NdmsUserManagementService } from '../../../../projects/shared/core/app/api/services/ndms-user-management.service';
import { UserApplicationModel } from '../../../../projects/shared/core/app/api/models/user-application-model';
import { UserModel } from '../../../../projects/shared/core/app/api/models/user-model';

@Component({
  selector: 'app-select',
  templateUrl: './app-select.component.html',
  styleUrls: ['./app-select.component.scss']
})
export class AppSelectComponent extends BaseViewComponent {
  @Input() set model(value: any[]) {
    this.applications = value;
    let applications = value.map(app => {
      return { id: app.appItemKey, display: app.appName }
    });
    this.lookupService.set("Applications", applications);
  }

  @Output() complete = new EventEmitter();
  @Output() cancel = new EventEmitter();
  
  applications: any[];
  formGroup: FormGroup;
  errorMessage: string = "";

  constructor(
    private _formBuilder: FormBuilder,
    private _ndmsUserManagementService: NdmsUserManagementService,
    private _toastService: ToastService,
    lookupService: LookupService) {
    super(lookupService);

    this.formGroup = this._formBuilder.group({
      accountJustification: ['', Validators.required],
      applicationKey: ['', Validators.required]
    });
  }

  onCancelClick() {
    this.cancel.emit();
  }

  onSaveClick() {
    let application: UserApplicationModel = {
      accountJustification: this.formGroup.get("accountJustification").value,
      appItemKey: this.formGroup.get("applicationKey").value
    }
    this.addApplication(application).then((result) => {
      if (result.accountStatus === 0) {
        this.errorMessage = result.message;
      }
      else {
        this.complete.emit();
      }
    }, error => {
        this.errorMessage = error.error;
    });
  }

  private addApplication(application: UserApplicationModel) {
    return new Promise<UserModel>((resolve, reject) => {
      this.safeSubscribe(this._ndmsUserManagementService.AddApp(application), data => {
        resolve(data);
      }, error => {
        this._toastService.showError(error);
        reject(error);
      });
    });
  }

}